/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Recent_ClearInputs */

const en_us2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const pt_br2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar`)
};

const es_419_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar`)
};

const pt_pt2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar`)
};

const fr_fr2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer`)
};

const de_de2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeren`)
};

const it_it2_search_recent_clear = /** @type {(inputs: Search_Recent_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Search_Recent_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_recent_clear = /** @type {((inputs?: Search_Recent_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Recent_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_recent_clear(inputs)
	if (locale === "es-419") return es_419_search_recent_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_search_recent_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_search_recent_clear(inputs)
	if (locale === "de-DE") return de_de2_search_recent_clear(inputs)
	if (locale === "it-IT") return it_it2_search_recent_clear(inputs)
	return en_us2_search_recent_clear(inputs)
});
export { search_recent_clear as "search.recent_clear" }